import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styless from '../Footer/Footer.module.css';
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";
import toast, { Toaster } from 'react-hot-toast';

// Component للروابط الخارجية
const ExternalLink = ({ to, children }) => (
  <a href={to} target="_blank" rel="noopener noreferrer" className={styless.socialIcon}>
    {children}
  </a>
);

export default function Footer() {
  const [email, setEmail] = useState("");

  const handleSubscribe = () => {
    if (!email) {
      toast.error("Please enter your email", { position: "top-right" });
      return;
    }

    const loadingToastId = toast.loading(
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <div className={styless.loader}></div>
        <span>Subscribing...</span>
      </div>,
      { position: "top-right" }
    );

    setTimeout(() => {
      toast.dismiss(loadingToastId);
      toast.success("Subscribed successfully!", { position: "top-right" });
      setEmail("");
    }, 2000);
  };

  return (
    <footer className={styless.footer}>
      <Toaster />
      <div className={styless.container}>
        <div className={styless.footerContent}>
          {/* Brand Section */}
          <div className={styless.brandSection}>
            <div className={styless.brandName}>
              <div className={styless.orangeLine}></div>
              <h2>KARZONE</h2>
            </div>
            <p className={styless.brandDescription}>
              Premium car rental service with the latest models and exceptional customer service. Drive your dream car today!
            </p>
            <div className={styless.socialIcons}>
              <ExternalLink to="https://www.facebook.com/servicemycar.uae/"><FaFacebookF /></ExternalLink>
              <ExternalLink to="https://x.com/Servicemycar_ae"><FaTwitter /></ExternalLink>
              <ExternalLink to="https://www.instagram.com/servicemycar.ae/"><FaInstagram /></ExternalLink>
              <ExternalLink to="https://www.linkedin.com/company/servicemycar/"><FaLinkedinIn /></ExternalLink>
              <ExternalLink to="https://www.youtube.com/@ServiceMyCarApp"><FaYoutube /></ExternalLink>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className={styless.quickLinks}>
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services </Link></li>
              <li><Link to="/cars">Cars </Link></li>
              <li><Link to="/contact">Contact </Link></li>
            </ul>
          </div>

          {/* Contact Us Section */}
          <div className={styless.contactUs}>
            <h3>Contact Us</h3>
            <div className={styless.contactItem}>
              <FaMapMarkerAlt className={styless.contactIcon} />
              <span>123 Drive Avenue, Auto City, CA 90210</span>
            </div>
            <div className={styless.contactItem}>
              <FaPhone className={styless.contactIcon} />
              <span>+91 8299431275</span>
            </div>
            <div className={styless.contactItem}>
              <FaEnvelope className={styless.contactIcon} />
              <span>info@hexagonservices.com</span>
            </div>
            <div className={styless.businessHours}>
              <h4>Business Hours</h4>
              <p>Monday - Friday: 8:00 AM - 8:00 PM</p>
              <p>Saturday: 9:00 AM - 6:00 PM</p>
              <p>Sunday: 10:00 AM - 4:00 PM</p>
            </div>
          </div>

          {/* Newsletter Section */}
          <div className={styless.newsletter}>
            <h3>Newsletter</h3>
            <p>Subscribe for special offers and updates</p>
            <div className={styless.newsletterForm}>
              <input
                type="email"
                placeholder="Your Email Address"
                className={styless.emailInput}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button
                className={styless.subscribeBtn}
                onClick={handleSubscribe}
              >
                Subscribe Now
              </button>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className={styless.footerBottom}>
          <div className={styless.copyright}>
            <span>© 2025 KARZONE. All rights reserved.</span>
          </div>
          <div className={styless.designCredit}>
            <span>
              Designed by <Link to="/hexagon-services">Hexagon Digital Services</Link>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
